
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"56","height":"26","viewBox":"0 0 56 26","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"36.128","cy":"6","r":"6","transform":"rotate(-90 36.128 6)","fill":"#F9B621"}}),_c('path',{attrs:{"d":"M20.127 0a6 6 0 110 12 6 6 0 010-12z","fill":"#3084B9"}}),_c('rect',{attrs:{"y":"18.873","width":"56","height":"7","rx":"3.5","fill":"#E8E8E8"}})])
          )
        }
      }
    